import { Auth } from "aws-amplify";

export const logout = async () => {
  await Auth.signOut();
  window.location.reload();
};
